
import { NewsContainer } from './components/NewsContainer';


const App = () => {
	return (
		<NewsContainer/>
	);
};

export default App;
